import mitt from 'mitt';
const toastBus = mitt();
export { toastBus };
